import { FETCH_CHANNELS } from "../types/channels";

export const fetchChannels = () => {
  return dispatch => {
    dispatch({
      type: FETCH_CHANNELS
    });
  };
};
